// import { memo, useEffect, useState, useRef } from "react";
// import { GetDataFromApiWithParams } from "../../../../../../services/api/ExecuteApiRequests";
// import IPDCFinalTable from "../../../../../../components/IPDCFinalTable";
// import { Box, Typography, Container } from "@mui/material";
// import { Link } from "react-router-dom";
// import MapIcon from "@mui/icons-material/Map";

// //prettier-ignore
// const EditImportedData = () => {

//     const [unapprovedData, setUnapprovedData] = useState([]);
//     const componentRef = useRef();
//     const [selectedColumns, setSelectedColumns] = useState([]);
//     const [loading, setLoading] = useState(true);
//     useEffect(() => {
//         const fetchMyImport = async () => {
//           const resultRow = await GetDataFromApiWithParams(`unapprovedSpatialData/${localStorage.getItem('user-id')}`);
//           if (resultRow.length > 0 && resultRow) {
//             setUnapprovedData(resultRow);
//             const cols = (await resultRow.length) ? Object.keys(resultRow[0]) : [];
//             setSelectedColumns(cols);
//             setUnapprovedData(resultRow);
//           }
//           setLoading(false);
//           //console.log(resultRow);
//         };
//         fetchMyImport();
//       }, []);  
  
//   return (
//     <Container>
//       {loading && <div>Loading...</div>}
//       <Link to="/ViewUnapprovedMap"><><MapIcon /><Typography>Go to Map View</Typography></></Link>
//       {unapprovedData?.length ? (
//         <IPDCFinalTable
//           ref={componentRef}
//           data={unapprovedData}
//           setData={setUnapprovedData}
//           selectedColumns={selectedColumns}
//           title="Unapproved spatial data"
//           attachmentLink="file_path"
//           hasAttachment={true}
//           isDeletable={true}
//           targetPoint="unapprovedSpatialData"
//           deleteKey="id"
//         />
//       ):<><Box><Typography>No unapproved, imported spatial data, available</Typography></Box></>}
//     </Container>
//   );
// };

// export default memo(EditImportedData);
///////////////
import { memo, useEffect, useState, useRef } from "react";
import { GetDataFromApiWithParams } from "../../../../../../services/api/ExecuteApiRequests";
import IPDCFinalTable from "../../../../../../components/IPDCFinalTable";
import { Box, Typography, Container } from "@mui/material";
import { Link } from "react-router-dom";
import MapIcon from "@mui/icons-material/Map";

const EditImportedData = () => {
    const [unapprovedData, setUnapprovedData] = useState([]);
    const componentRef = useRef();
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [loading, setLoading] = useState(true);

    // Function to extract user ID from JWT token
    const getUserIdFromToken = () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                console.error('No token found in localStorage');
                return null;
            }

            // JWT tokens have 3 parts separated by dots: header.payload.signature
            const payload = token.split('.')[1];
            if (!payload) {
                console.error('Invalid JWT token format');
                return null;
            }

            // Decode base64 payload
            const decodedPayload = JSON.parse(atob(payload));
            
            const userId = decodedPayload.id;
            return userId;
            
        } catch (error) {
            console.error('Error extracting user ID from token:', error);
            return null;
        }
    };

    useEffect(() => {
        const fetchMyImport = async () => {
            const userId = getUserIdFromToken();
            
            if (!userId) {
                console.error('Could not extract user ID from token');
                setLoading(false);
                return;
            }
            
            try {
                const resultRow = await GetDataFromApiWithParams(`unapprovedSpatialData/${userId}`);
                
                if (resultRow && resultRow.data && Array.isArray(resultRow.data) && resultRow.data.length > 0) {
                    setUnapprovedData(resultRow.data);
                    const cols = Object.keys(resultRow.data[0]);
                    setSelectedColumns(cols);
                } else if (resultRow && Array.isArray(resultRow) && resultRow.length > 0) {
                    // If the API returns array directly (not wrapped in data property)
                    setUnapprovedData(resultRow);
                    const cols = Object.keys(resultRow[0]);
                    setSelectedColumns(cols);
                    
                } else {
  
                    setUnapprovedData([]);
                }
            } catch (error) {
                console.error('Error fetching unapproved data:', error);
                setUnapprovedData([]);
            } finally {
                setLoading(false);
            }
        };
        
        fetchMyImport();
    }, []);  

    return (
        <Container>
            {loading && <div>Loading...</div>}
            <Link to="/ViewUnapprovedMap">
                <MapIcon />
                <Typography>Go to Map View</Typography>
            </Link>
            
            {unapprovedData?.length ? (
                <IPDCFinalTable
                    ref={componentRef}
                    data={unapprovedData}
                    setData={setUnapprovedData}
                    selectedColumns={selectedColumns}
                    title="Unapproved spatial data"
                    attachmentLink="file_path"
                    hasAttachment={true}
                    isDeletable={true}
                    targetPoint="unapprovedSpatialData"
                    deleteKey="id"
                />
            ) : (
                <Box>
                    <Typography>No unapproved, imported spatial data available</Typography>
                </Box>
            )}
        </Container>
    );
};

export default memo(EditImportedData);
///////////////